import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import PermitList from '../ui/PermitList';
import WriteFAB from '../../ui/WriteFAB';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { useDispatch, useSelector } from 'react-redux';
import WeeklyCalendar from './../ui/WeekCalendar';
import FilterBottomSheet from './../../ui/FilterBottomSheet';

export default function M_PER_CUSTOM(props) {
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();

  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { selectedFilter } = useSelector((state) => state.permit);

  const handleDateSelect = () => {
    props.SearchLogic1();
  };

  const filteredPermits = props.rowData1?.filter((item) => {
    const isStatusMatch =
      selectedFilter === '전체' || item.gubun === selectedFilter;
    return isStatusMatch;
  });

  const handleWriteClick = () => {
    dispatch(CommonActions.setActiveStep(1));
    navigate('/M_Permit/write');
  };

  return (
    <>
      <div className="flex flex-col gap-1 px-4 text-base">
        {/* 주간 캘린더 */}
        <WeeklyCalendar
          onDateSelect={handleDateSelect}
          refreshClick={props.refreshClick}
        />

        {/* 작업허가서 목록 */}
        <PermitList data={filteredPermits} SaveLogic1={props.SaveLogic1} />

        {/* 바텀시트 부분 */}
        {bottomSheetState.bottom && bottomSheetState.type === 'filter' && (
          <FilterBottomSheet SearchLogic1={props.SearchLogic1} />
        )}

        {/* 작성 버튼 (FAB) */}
        {<WriteFAB handleWriteClick={handleWriteClick} />}
      </div>
    </>
  );
}
